<template>
	<div id="aside" class="app-aside fade shadow white nav-expand white" aria-hidden="true">
		<div class="sidenav modal-dialog dk white" ui-class="white">
			<div class="flex">
				<div class="scroll">
					<div class data-nav>
						<ul class="nav sub">
							<template v-for="group in sidenavGroups">
								<li :key="'header:' + group.name" class="nav-header mt-2">
									<span class="text-xs text-theme hidden-folded">{{ group.name }}</span>
								</li>
								<li v-for="task in group.tasks" :key="task.name" :class="isActivePage(task)">
									<a :href="`#${task.path}`" class="active" v-if="!task.subtasks">
										<span class="nav-icon" v-if="task.icon">
											<i class="fa" :class="{ [task.icon]: true }"></i>
										</span>
										<span class="nav-icon" v-if="task.m_icon">
											<i class="material-icons tiny">{{ task.m_icon }}</i>
										</span>
										<span v-if="task.showMailCounts" class="nav-badge">
											<b v-if="importantMail > 0" class="badge badge-pill danger">{{
												importantMail
											}}</b>
											<b
												v-if="importantMail == 0 && unreadMail > 0"
												class="badge badge-pill success"
												>{{ unreadMail }}</b
											>
										</span>
										<span class="nav-text">{{ task.name }}</span>
									</a>
									<a @click="toggleExpand(task)" class="active" v-if="task.subtasks">
										<span class="nav-icon" v-if="task.icon">
											<i class="fa" :class="{ [task.icon]: true }"></i>
										</span>
										<span class="nav-icon" v-if="task.m_icon">
											<i class="material-icons tiny">{{ task.m_icon }}</i>
										</span>
										<span class="nav-caret">
											<i class="fa fa-caret-left"></i>
										</span>
										<span class="nav-text">{{ task.name }}</span>
									</a>
									<ul
										class="nav-sub"
										v-if="task.subtasks"
										:style="{ 'max-height': `${32 * task.subtasks.length}px` }"
									>
										<li
											v-for="subtask in task.subtasks"
											:key="subtask.name"
											:class="isActivePage(subtask)"
										>
											<a :href="`#${subtask.path}`" class="waves-effect">
												<span class="nav-text">{{ subtask.name }}</span>
											</a>
										</li>
									</ul>
								</li>
							</template>
							<li class="mb-3"></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import AuthService from "@/services/AuthService";

export default {
	name: "Sidenav",
	props: {
		important: true,
		unread: true,
		groups: true,
		supersededBy: {
			type: Object,
			default() {
				return {};
			}
		},
		filteredGroups: true
	},
	data() {
		return {
			user: {},
			loaded: false,

			unreadMail: 0,
			importantMail: 0
		};
	},
	created() {
		AuthService.getUser().then(user => {
			this.user = user;
			//Wait to load tasks until we have the user
			this.loaded = true;
		});
	},
	mounted() {
		$(window).on("resize.sidenav", function() {
			var $w = $(window).width(),
				$lg = 1200,
				$md = 991,
				$sm = 768;
			if ($w > $lg) {
				$(".aside-lg").modal("hide");
			}
			if ($w > $md) {
				$("#aside").modal("hide");
				$(".aside-md, .aside-sm").modal("hide");
			}
			if ($w > $sm) {
				$(".aside-sm").modal("hide");
			}
		});
	},
	beforeDestroy() {
		this.destroyModalBackdrop();
	},
	destroyed() {
		$(window).off("resize.sidenav");
	},
	computed: {
		sidenavGroups() {
			if (!this.loaded) {
				return {};
			}

			let groupDefs = [];
			_.each(this.groups, (groupDef, name) => {
				//Only construct a group if the user has access to at least one task in it
				if (this.hasAnyPermissionInGroup(groupDef, this.user.role)) {
					let group = { name: name, tasks: [] };
					_.each(groupDef, taskDef => {
						if (taskDef.subtasks) {
							let subtasks = this.getPermittedSubtasks(taskDef);
							if (subtasks.length == 0) {
								//No permitted subtasks, don't make the task group at all
							} else if (subtasks.length == 1) {
								//One permitted subtask, promote the subtask to a normal task
								let task = _.cloneDeep(taskDef);
								if (subtasks[0].singleName) {
									task.name = subtasks[0].singleName;
								}
								delete task.subtasks;
								task.path = subtasks[0].path;
								group.tasks.push(task);
							} else {
								//Multiple permitted subtasks, create a collapsible group for them
								let task = _.cloneDeep(taskDef);
								task.subtasks = subtasks;
								group.tasks.push(task);
							}
						} else {
							//No subtasks at all, just a normal task
							if (this.hasPermissionMulti(taskDef.permission, this.user.role)) {
								group.tasks.push(taskDef);
							}
						}
					});
					groupDefs.push(group);
				}
			});

			this.$emit("update:filteredGroups", groupDefs);
			return groupDefs;
		}
	},
	watch: {
		important() {
			this.importantMail = this.important;
		},
		unread() {
			this.unreadMail = this.unread;
		}
	},
	methods: {
		hasPermission(perm, role) {
			//console.log("hasPermission", perm, role);
			//Don't count this permission if the user has a permission that completely includes its functionality
			//(to prevent redundancy)
			var super_perms = this.supersededBy[perm];
			if (super_perms) {
				let has_super = false;
				_.each(super_perms, perm => {
					if (role[perm]) {
						has_super = true;
					}
				});
				if (has_super) {
					return false;
				}
			}

			//Handle temporary landing page, which is always available unless it's superseded
			if (perm == "page_landing") {
				return true;
			}

			if (role[perm]) {
				return true;
			}
			return false;
		},

		//Match either single or multiple permissions
		hasPermissionMulti(permission, role) {
			if (typeof permission == "string") {
				return this.hasPermission(permission, role);
			} else if (typeof permission == "object") {
				//If permission is defined as an array of multiple options, just check that at least one is valid
				let hasPerm = false;
				_.each(permission, p => {
					if (this.hasPermission(p, role)) {
						hasPerm = true;
					}
				});
				return hasPerm;
			}
			return false;
		},

		hasAnyPermissionInGroup(group, role) {
			var hasPerm = false;
			_.each(group, task => {
				if (task.subtasks) {
					_.each(task.subtasks, subtask => {
						if (!subtask.permission || this.hasPermissionMulti(subtask.permission, this.user.role)) {
							hasPerm = true;
						}
					});
				} else {
					if (this.hasPermissionMulti(task.permission, this.user.role)) {
						hasPerm = true;
					}
				}
			});
			return hasPerm;
		},
		getPermittedSubtasks(task) {
			var subtasks = [];
			_.each(task.subtasks, subtask => {
				if (!subtask.permission || this.hasPermissionMulti(subtask.permission, this.user.role)) {
					subtasks.push(subtask);
				}
			});
			return subtasks;
		},
		isActivePage(task) {
			if (task.path) {
				var active = _.startsWith(this.$route.path, task.path);
				return { "nav-active": active };
			} else {
				var active = false;
				_.each(task.subtasks, subtask => {
					active = active || _.startsWith(this.$route.path, subtask.path);
				});
				active = active || this.expandedTask == task;

				return { /* "nav-active": active, */ active: active };
			}
		},
		toggleExpand(task) {
			if (this.expandedTask == task) {
				this.expandedTask = false;
			} else {
				this.expandedTask = task;
			}
		},
		destroyModalBackdrop() {
			$("body").removeClass("modal-open");
			$(".modal-backdrop").remove();
		}
	}
};
</script>

<style scoped>
.sidenav .flex::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}
.sidenav .flex::-webkit-scrollbar-thumb {
	border-radius: 8px;
	background-color: rgba(0, 0, 0, 0.25);
	-webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.sidenav {
	width: 13rem;
}

.app-aside .scroll {
	width: 13rem;
}

/* Side nav visible */
@media (min-width: 992px) {
	.app-aside {
		width: 13rem;
		min-height: calc(100% - 65px);
	}

	.app-aside .sidenav {
		height: calc(100% - 112px);
	}
}

/* Side nav collapsed */
@media (max-width: 991px) {
}

.nav-active > a {
	color: black !important;
}

/* li.active {
	background-color: lightgray;
} */
.nav-sub {
	transition: max-height 0.25s ease 0s;
}
:not(.active) > .nav-sub {
	max-height: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/global/Sidenav.vue